/**
 * This composable is a temporary helper file that allows components to reactively check for the
 * presence of a theme (i.e., the `data-theme` attribute on the document element).
 *
 * This is ONLY necessary to keep support for legacy compatibility.
 *
 * Once all components have been updated to use the new theming system, this file should be removed,
 * and components should no longer check for the presence of a theme, as the new theming system will
 * handle this internally.
 *
 * Please add @todo comments to any components that are using hasTheme with information on how to
 * migrate to the new theming system when hasTheme is removed.
 */

import { ref } from 'vue';

const hasTheme = ref(
  typeof document !== 'undefined' && document.documentElement.hasAttribute('data-theme'),
);

const currentTheme = ref(
  (typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme')) || '',
);

if (typeof document !== 'undefined') {
  new MutationObserver(() => {
    hasTheme.value = document.documentElement.hasAttribute('data-theme');
    currentTheme.value = document.documentElement.getAttribute('data-theme') || '';
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
}

// eslint-disable-next-line import/prefer-default-export
export function useTheme() {
  return { hasTheme, currentTheme };
}
